import { render, staticRenderFns } from "./Scene9.vue?vue&type=template&id=fa0ef8e4&scoped=true"
import script from "./Scene9.vue?vue&type=script&lang=js"
export * from "./Scene9.vue?vue&type=script&lang=js"
import style0 from "./Scene9.vue?vue&type=style&index=0&id=fa0ef8e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0ef8e4",
  null
  
)

export default component.exports